// router/routes.ts
const securityKillSwitch = () => {
    window.stop();
    document.documentElement.innerHTML = `
        <div style="font-family: sans-serif; text-align: center; margin-top: 50px;">
            <h1>404 Not Found</h1>
            <hr><p>nginx</p>
        </div>`;
};

export default [
    {
        path: "/kanban",
        name: "kanban",
        component: () => import('../components/kanban/kanban.vue'),
        meta: {
            requiresAuth: true,
            title: "Kanban"
        },
        beforeEnter: (to, from, next) => {
            // if (window.self === window.top) {
            //     return securityKillSwitch();
            // }

            const { account_id, host } = to.query;
            if (!account_id || !host) {
                return securityKillSwitch();
            }

            next();
        }
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: { render: () => null },
        beforeEnter: () => {
            securityKillSwitch();
        }
    }
]